export enum AccessType {
	FuneralPlan = "FuneralPlan",
	PersonalInfo = "PersonalInfo",
	CPF = "CPF",
	AdvanceCarePlanV2 = "AdvanceCarePlanV2", // ACP Form
	LastingPowerOfAttorney = "LastingPowerOfAttorney",
	Will = "Will",
}
